import React, { createContext, useState, useContext, useCallback } from 'react';
import { useNavigation } from './_NavigationContext';
import { DebugConfig } from './_DebugConfig';
import { debug } from './_DebugLog';

export const MapContext = createContext();

export const useMapContext = () => useContext(MapContext);

export const MapProvider = ({ children }) =>
{
	const { navigateSetParam } = useNavigation();

	const queryParams = new URLSearchParams(window.location.search);

	const bfFromUrl = queryParams.get('bf') === '1';
	const [bfMapState, setBFMapState] = useState(bfFromUrl);

	const hasPinsFromUrl = (parseInt(queryParams.get('no-pins')) > 0) ? 0 : 1;
	const [hasPinsState, setHasPinsState] = useState(hasPinsFromUrl);
	
	const [autoCenterEnabled, setAutoCenterEnabled] = useState(true);

	const [hasTargetPin, setHasTargetPin] = useState(false);
	const [targetPinLatLng, setTargetPinLatLng] = useState(null);

	const [selectedPin, setSelectedPin] = useState({ type: null, id: null });

	const setBFMap = useCallback((value) =>
	{
		setBFMapState(value);
		navigateSetParam('bf', value ? 1 : 0, 0);
	},
	[navigateSetParam]);

	const setHasPins = useCallback((value) =>
	{
		setHasPinsState(value);
		navigateSetParam('no-pins', value === 0 ? 1 : 0, 0);
	},
	[navigateSetParam]);

	const toggleAutoCenter = useCallback(() =>
	{
		setAutoCenterEnabled(!autoCenterEnabled);
	},
	[autoCenterEnabled]);

	const setAutoCenter = useCallback((value) =>
	{
		setAutoCenterEnabled(value);
	},
	[]);

	const showTargetPin = useCallback((latLng) =>
	{
		setHasTargetPin(true);
		setTargetPinLatLng(latLng);
	},
	[]);

	const hideTargetPin = useCallback(() =>
	{
		setHasTargetPin(false);
		setTargetPinLatLng(null);
		setSelectedPin({ type: null, id: null });
	},
	[]);

	const selectTargettedPin = useCallback((type, id) =>
	{
		setSelectedPin({ type, id });
	},
	[]);

	const isSelectedPin = useCallback((type, id) =>
	{
		if (!selectedPin) return false;
		return (selectedPin.type === type && selectedPin.id === id);
	},
	[selectedPin]);

	const [gpsCheckEnabled, setGPSCheckEnabled] = useState(
		() => DebugConfig.getSetting(DebugConfig.COOKIES.GPS_CHECK, DebugConfig.DEFAULTS.GPS_CHECK)
	);
	
	const setGPSCheck = useCallback((value) => {
		setGPSCheckEnabled(value);
		DebugConfig.saveSetting(DebugConfig.COOKIES.GPS_CHECK, value);
		debug.log(`GPS check ${value ? 'enabled' : 'disabled'} in debug mode`);
	}, []);

	return (
		<MapContext.Provider value={
		{
			bfMapState,
			setBFMap,
			hasPinsState,
			setHasPins,
			autoCenterEnabled,
			toggleAutoCenter,
			setAutoCenter,
			hasTargetPin,
			targetPinLatLng,
			showTargetPin,
			hideTargetPin,
			selectTargettedPin,
			isSelectedPin,
			gpsCheckEnabled,
			setGPSCheck
		}
		}>
			{children}
		</MapContext.Provider>
	);
};